import React, { useCallback, useState } from "react";
import { Input, Portal, Space } from "@thenounproject/lingo-core";

import ModalHeader from "../../../../app/_components/ModalHeader";
import ModalFooter from "../../../../app/_components/ModalFooter";
import ModalBody from "../../../../app/_components/ModalBody";

import useShowModal from "@redux/actions/useModals";
import useDuplicatePortal from "@redux/actions/portals/useDuplicatePortal";
import useNotifications from "@redux/actions/useNotifications";

type Props = {
  portal: Portal;
  space: Space;
};

const DuplicatePortalModal: React.FC<Props> = ({ portal, space }) => {
  const [portalName, setPortalName] = useState(""),
    { dismissModal } = useShowModal(),
    { showNotification } = useNotifications();

  const [duplicatePortal, { isProcessing, error }] = useDuplicatePortal();

  const submit = useCallback(async () => {
    const name = portalName.trim();
    const res = await duplicatePortal({
      portalId: portal.id,
      spaceId: space.id,
      name: name || undefined,
    });

    if (res.isSuccess) {
      dismissModal();
      showNotification({
        message: "Your portal is being duplicated. It may take up to a few minutes.",
      });
    }
  }, [dismissModal, portalName, portal.id, space.id, duplicatePortal, showNotification]);

  return (
    <>
      <ModalHeader title="Duplicate Portal" />
      <ModalBody>
        <Input
          id="portal-name"
          label="Portal Name"
          value={portalName}
          onChange={e => setPortalName(e.target.value)}
          onSubmit={submit}
          placeholder={`${portal.name} (Duplicate)`}
          autoFocus
          message={error?.message}
          inputStyle={error ? "error" : null}
        />
      </ModalBody>
      <ModalFooter
        primary={{
          text: isProcessing ? "Duplicating Portal..." : "Duplicate Portal",
          onClick: submit,
          disabled: isProcessing,
        }}
      />
    </>
  );
};

export default DuplicatePortalModal;
